export default __webpack_public_path__ + "static/media/Planeta.aed1b3d7.png";